import { render } from "./AnnexAlarmStatusHelper.vue?vue&type=template&id=66510dcb&ts=true"
import script from "./AnnexAlarmStatusHelper.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmStatusHelper.vue?vue&type=script&lang=ts"

import "./AnnexAlarmStatusHelper.vue?vue&type=style&index=0&id=66510dcb&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__